export const environment = {
  production: false,
  apiUrl: 'https://devapi.cityspeak.in'
};
